import React, { useState, useEffect } from "react";
import { message, Spin } from "antd";
import Button from "../../components/Button";
import Bridge from "../../constants/Bridge";

const VerifyOtp = () => {
  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("forgot_email")) {
      window.location.assign("/");
    }
  }, []);

  const verifyOtp = () => {
    if (!otpValue) {
      message.warning("OTP is required");
      return;
    }
    const params = {
      email: localStorage.getItem("forgot_email"),
      otp: otpValue,
    };
    setLoading(true);
    Bridge.forgotPassword.verifyOtp(params).then((res) => {
      if (res.status === 1) {
        localStorage.setItem("forgot_verified", true);
        message.success(res.message);
        setLoading(false);
        window.location.assign("/reset-password");
      } else {
        message.warning(res.message);
        setLoading(false);
      }
    });
  };

  return (
    <div
      className="multisteps-form__panel js-active login-page"
      data-animation="slideVert"
    >
      <div className="inner pb-50">
        <div
          className="wizard-content-item text-center"
          style={{ paddingTop: 0 }}
        >
          <div
            className="wizard-content-item text-center"
            style={{ paddingTop: 0 }}
          >
            <img
              src="/assets/img/ecas-logo-white.png"
              className="logo-img"
              style={{
                margin: "0 auto",
                marginBottom: 0,
                maxWidth: 220,
                width: 240,
              }}
            />
            <h2>
              EALS Consortia Portal
              <br /> Verify Code
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 m-auto">
            <div className="wizard-content-form">
              <Spin spinning={loading}>
                <div className="wizard-form-field">
                  <div className="wizard-form-input position-relative form-group has-float-label">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Verification Code"
                      value={otpValue}
                      onChange={(e) => setOtpValue(e.target.value)}
                    />
                    <label>Verification Code</label>
                  </div>
                  <center>
                    <Button
                      to="#"
                      isClickable={true}
                      click={verifyOtp}
                      style={{ width: "fit-content" }}
                    >
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                      &nbsp;&nbsp; Verify Code
                    </Button>
                  </center>
                </div>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
